import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const resetUserPin = createAsyncThunk("resetUserPin", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.post(`${API_KEY}/api/president/reset-pin`, data, {
      headers: { Authorization: `Barear ${token}` },
      "Content-Type": "application/json",
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  resetUserPinData: null,
  isError: false,
  errorMessage: "",
};
const resetUserPinSlice = createSlice({
  name: "resetUserPin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetUserPin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(resetUserPin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.resetUserPinData = action.payload;
    });
    builder.addCase(resetUserPin.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default resetUserPinSlice.reducer;
